// @flow
import { ACTIONS } from '../constants';
import setNotificationSettingsAllEmail from '../api/setNotificationSettingsAllEmail';

const setNotificationSettingsAllEmailAction = (
    enabled: boolean,
    token: string
) => (dispatch: Function) => {
    setNotificationSettingsAllEmail(enabled, token);

    dispatch({
        type: ACTIONS.NOTIFICATION_SETTINGS_SET_ALL_EMAIL,
        enabled
    });
};

export default setNotificationSettingsAllEmailAction;



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/state/setNotificationSettingsAllEmail.js